module.exports = __webpack_public_path__ + "img/gourmet.2984a0f3.jpg";